module.exports = __webpack_public_path__ + "static/media/TT.fbc6495c.svg";